"use client";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { FontLineHeightMd, FontSize200, ColorTextDefault } from "@nxt-costco-com/forge-design-tokens";
const StyledProductSimpleTitleText = styled(Typography)(({ maxLineNumbers = 2 }) => {
  return {
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: maxLineNumbers,
    color: ColorTextDefault,
    display: "-webkit-box",
    fontSize: FontSize200,
    lineHeight: FontLineHeightMd,
    lineClamp: maxLineNumbers,
    overflow: "hidden"
  };
});
export {
  StyledProductSimpleTitleText
};
